import React from "react";
import { Box } from "@mui/material";
import useIsUkUserCountry from "src/utils/hooks/useIsUkUserCountry";
import WarningBox from "./WarningBox";

/**
 * UK-only general information disclaimer shown on the Markets pages
 * (Cryptocurrencies list and Crypto heatmap). Renders nothing for
 * users whose address is outside the UK.
 */
export const MarketsDisclaimer: React.FC = () => {
  const isUkUser = useIsUkUserCountry();

  if (!isUkUser) return null;

  return (
    <Box sx={{ mt: 3, mb: 2, width: "100%" }}>
      <WarningBox>
        The information on this page is general information only and does not constitute financial,
        investment, legal, or tax advice. Crypto assets are volatile and may result in loss. Consider
        your own circumstances before investing.
      </WarningBox>
    </Box>
  );
};

export default MarketsDisclaimer;
